import { ImageType } from 'react-images-uploading';
import client from 'shared/ApiClient';

export async function addImages(images: ImageType[], user: any) {
    let imgs: ImageType[] = [];

    for (let i = 0; images.length > i; i++) {
        let image: ImageType = images[i];
        let form_data = new FormData();

        form_data.append('title', (image.file as File).name);
        form_data.append('content', 'image-attachment');
        form_data.append('user', user.id);
        form_data.append('image', image.file as File, (image.file as File).name);

        const res = await client(
            'api/image/',
            {
                body: form_data,
            },
            false,
        );

        imgs.push(res);
    }

    return imgs;
}